import {
  Avatar,
  AvatarSkeleton,
  CbhIcon,
  iconSizeByAvatarSize,
} from "@clipboard-health/ui-components";
import { type AvatarSize } from "@clipboard-health/ui-theme";

interface WorkplaceAvatarProps {
  size?: AvatarSize;
  pictureUrl?: string;
  isLoading?: boolean;
}

export function WorkplaceAvatar(props: WorkplaceAvatarProps) {
  const { size = "medium", pictureUrl, isLoading } = props;

  if (isLoading) {
    return <AvatarSkeleton size={size} />;
  }

  return (
    <Avatar src={pictureUrl} size={size}>
      <CbhIcon type="building" size={iconSizeByAvatarSize[size]} />
    </Avatar>
  );
}
